// extracted by mini-css-extract-plugin
export default {"home":"index_home__l7hGf","content":"index_content__nryEE","top":"index_top__xOuwr","table":"index_table__TBnH9"};